<h1 mat-dialog-title>Deny Application for {{data.applicant.user.realName}}</h1>
<mat-dialog-content [formGroup]="form">
  Select the reason(s) for denying this application:
  <ul>
    <li>
      <mat-checkbox formControlName="duplicateAccount">Duplicate account</mat-checkbox>
      <mat-form-field *ngIf="form.value.duplicateAccount" appearance="fill" style="margin-top: 10px; width: 100%;">
        <mat-label>Email address of the original account</mat-label>
        <input type="email" matInput formControlName="duplicateAccountEmail" required>
        <mat-error *ngIf="form.get('duplicateAccountEmail')?.hasError('required')">This field is required</mat-error>
        <mat-error *ngIf="form.get('duplicateAccountEmail')?.hasError('email')">Please enter a valid email address</mat-error>
      </mat-form-field>
    </li>
    <li><mat-checkbox formControlName="notEnoughRooms">Not enough rooms played</mat-checkbox></li>
    <li>
      <mat-checkbox formControlName="custom">Custom response</mat-checkbox><br>
      <mat-form-field *ngIf="form.value.custom" appearance="fill">
        <mat-label>Custom instructions</mat-label>
        <textarea matInput formControlName="customInstructions" [disabled]="!form.value.custom"
                  cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2"></textarea>
      </mat-form-field>
    </li>
    <li>
      <mat-checkbox formControlName="ccMe">CC me on the email</mat-checkbox>
    </li>
  </ul>
</mat-dialog-content>
<div mat-dialog-actions align="end">
  <button mat-raised-button color="secondary" (click)="cancel()">
    Cancel
  </button>
  <button mat-raised-button color="primary" (click)="submit()" [disabled]="!formIsValid()">
    Deny Application
  </button>
</div>
